module.exports = __webpack_public_path__ + "img/vn_qrcode_fb.6d5d2fe.webp";